import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { CommonApiData, initializeFilterData } from "../../EnvConfig/env_config";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey, deleteData } from "../CommonComponents/CustomHooks";
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, handleDownloadExcel, readFile } from "../CommonComponents/ExportData";
import { FormButton, ImportButton, InputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";
import { setSubLoading } from "../../Redux/Services/AuthSlice";

const CountryMaster = ({ menuText }) => {
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [HandleChoose, setHandleChoose] = useState(false)
    const [Status, setStatus] = useState([])
    const [ImportData, setImportData] = useState([])
    const [Name, setName] = useState('');
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const [hideForm, setHideForm] = useState(true)
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [disableEdit, setDisableEdit] = useState(false)
    const [formData, setFormData] = useState({
        "active": true,
        "countryID": "",
        "countryName": "",
        "countryCode": '',
    })

    const handleClear = () => {
        setFormData({
            "active": true,
            "countryID": "",
            "countryName": "",
            "countryCode": '',
        });
        filterData.SearchText = ''
        setStatus([])
        setImportData([])
        setHandleChoose(false)
        setName(false)
      //  inputrefs.current['txtCountryCode'].focus();
        BulkClearData(setName)
        getCountryMasterData()
        setDisableEdit(false)
    };

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Master/InsertUpdateCountryMaster', formData)
        await dispatch(setSubLoading(false))
        if (data.status === 'ERROR' || data.status === 'EXPIRED' || data.status === 'UNAUTHORIZED' || data.status === 'SUCCESS') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
        }
    }

    const handleDelete = async (ID) => {
        await dispatch(setSubLoading(true))
        await deleteData('/api/Master/DeleteCountryMaster', { countryID: ID }, getCountryMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    //Start Bulk Upload
    const Data = CommonApiData()
    let IData = {
        ...Data,
        "cityID": "",
    }

    const DownloadFormat = async () => {
        await DownloadFileAtURL('CountryMaster.xlsx')
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'CountryMasterError')
    }

    const BulkSubmit = async (e) => {
        await dispatch(setSubLoading(true))
        let data = await readFile(e)
        setImportData(data.exceljson)
        setName(data.FileName)
        await dispatch(setSubLoading(false))
        let a = document.querySelectorAll('.bulk-upload');
        if (a.length > 0) {
            a[0].childNodes[2].innerHTML = data.FileName;
        }
    };

    const handleBulk = async () => {
        if (ImportData.length !== 0) {
            if ((Object.keys(ImportData[0])).includes("CountryCode", "CountryName", "Active")) {
                await dispatch(setSubLoading(true))
                let Data = await HandleBulkInsertData('/api/Master/InsertUpdateCountryMaster', ImportData, IData, getCountryMasterData)
                await setStatus(Data)
                await dispatch(setSubLoading(false))
                await NotificationSound('INFO', `Success : ${Data.SuccessCount} Error : ${Data.ErrorCount}`);
                BulkClearData(setName)

            } else {
                await NotificationSound('ERROR', 'Header Format is not valid !');
                BulkClearData(setName)
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data.!');
            BulkClearData(setName)
        }
    }
    //End Bulk Upload
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleEdit = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall('/api/Master/EditCountryMaster', { countryID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR'|| editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setDisableEdit(true)
            let record = editData.data
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }
    }

    let PageName = "CountryMaster"

    const getCountryMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Master/ShowCountryMaster', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }



    const handleChange1 = (event, value) => {
        getCountryMasterData(value);
    };

    useEffect(() => {
        getCountryMasterData();
    }, [sortConfig])

    useEffect(() => {
       // inputrefs.current['txtCountryCode'].focus();
        document.title = 'Country Master'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">{menuText ? menuText : FindTranslatedKey('Country Master')}</h6>
                    
                </div>
                <div className='card-body row'>
                    <div className='col-md-6 col-lg-8'>
                       {/* {hideForm ? <></> : <>*/} <div className='row'>
                            <InputBox
                                divclassname='col-md-4 col-sm-6 mb-3'
                                label='Country Code'
                                PlaceHolderText='Country Code'
                                required={true}
                                inputrefs={inputrefs}
                                disabled={disableEdit}
                                id='txtCountryCode'
                                value={formData.countryCode}
                                maxLength='50'
                                onChange={(e) => {
                                    setFormData({ ...formData, countryCode: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtCountryName'].focus();
                                    }
                                }}
                            />

                            <InputBox
                                divclassname='col-md-4 col-sm-6 mb-3'
                                label='Country Name'
                                PlaceHolderText='Country Name'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtCountryName'
                                value={formData.countryName}
                                maxLength='50'
                                onChange={(e) => {
                                    setFormData({ ...formData, countryName: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtActive'].focus();
                                    }
                                }}
                            />

                            <Switch
                                label='Active'
                                inputrefs={inputrefs}
                                id='txtActive'
                                checked={formData.active}
                                onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['btnSave'].focus() };
                                }}
                            />
                        </div>{/*</> }*/}
                       
                        <div className='row pb-1 mb-4'>

                            <FormButton
                                id='btnSave'
                                inputrefs={inputrefs}
                                //save={false}
                                handleSubmit={handleSubmit}
                                handleExport={async () => {
                                    await dispatch(setSubLoading(true))
                                    await handleDownloadExcel('/api/Master/ShowCountryMaster', filterData, 'CountryMaster')
                                    await dispatch(setSubLoading(false))
                                }}
                                importData={true}
                                BulkSubmit={(e) => BulkSubmit(e)}
                                handleBulk={handleBulk}
                                UploadState={HandleChoose}
                                FileName={Name}
                                downloadFormat={DownloadFormat}
                                HandleChoose={() => setHandleChoose(!HandleChoose)}
                                handleClear={handleClear} />

                        </div>
                       
                    </div>
                    {/*{hideForm ? <></> : <> */}<div className='d-flex col-md-6 col-lg-4 h-25'>
                        <ImportButton
                            handleBulk={handleBulk}
                            BulkSubmit={(e) => BulkSubmit(e)}
                            downloadFormat={DownloadFormat}
                            ErrorData={ErrorData}
                            Status={Status}
                            HeaderFormat="PayMode, Active"
                            fileName={Name}
                        >
                        </ImportButton>
                    </div>{/*</> }*/}
                    <Table
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        PageName={PageName}
                        loading={loading}
                        handleFilter={() => {
                            getCountryMasterData()
                            setFilterData({
                                ...filterData,
                            })
                        }}
                        filterData={filterData}
                        tableData={result}
                        setFilterData={setFilterData}
                        currentPageNo={currentPageNo}
                        handleChange1={handleChange1}
                        handleSorting={handleSorting}
                        sortConfig={sortConfig}
                    />
                </div>
            </div>

           
        </>
    )
}

export default CountryMaster;